
























































































































































































// require('./lib/ui/root.js');

import ripple from "../../components/ripple.vue"
import tooltip from "../../components/tooltip.vue"
import gbutton from "../../components/button.vue"
import graph from "../../components/graph.vue"
import warningPopup, {WarningInterface} from "../../components/warningPopup.vue"
import inlineTextEdit from "../../components/inlineTextEdit.vue"

import dropdown, { DropdownInterface, DropdownItem } from "../../components/dropdownMenu.vue"
import dateSelector from "../../components/dateSelector.vue"
import DropdownMenu from "../../components/dropdownMenu.vue";
import moment,{ weekdays, Moment } from "moment";

import {frontendClient} from "../../lib/client"
import {HTTPPostAPI} from "../../lib/httpapi"

import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { setInterval } from "timers";

@Component({
    components : {
        ripple,
        gbutton,
        graph,
        tooltip,
        dateSelector,
        warningPopup,
        DropdownMenu,
        dropdown,
        inlineTextEdit,
    },
})
export default class Staff extends Vue{
    fromSelector:boolean = false;
    toSelector:boolean = false;

    moment = moment;

    openMore:boolean = false;
    
    range:{
        from:number,
        to:number
    } = {
        from: new Date().setHours(0,0,0,0),
        to: new Date().setHours(23,59,59,59)
    };

    searchVal:string = null;

    selectedStaff:any = null;
    selectedStaffGraph:any = null;

    parameters:DropdownInterface = {
        type: "options",
        items: [
            {
                name:"Jobs",
                icon: 'assignment',
                function: () => {},
                focus: true,
            },
            {
                name:"Payments",
                icon: 'attach_money',
                function: () => {},
                focus: true,
            },
            {
                name:"Letters",
                icon: 'mail',
                function: () => {},
                focus: true,
            },
        ]
    }

    getDates(){
        this.range.from = moment(this.range.to).subtract(7, 'days').toDate().setHours(0,0,0,0);
    }



    redirect(route,parameters?){
        if(parameters){
            this.$router.replace({ name: route, params: parameters});
        }else{
            this.$router.push({ name: route, params: parameters});
        }
    };


    editUser(user){
        this.$emit("editPrompt", { instance:"walker",object:user})
    }

    async deleteUser(user){
        let warning = new warningPopup();
        let warningItem:WarningInterface = {
            text:"Are you sure you want to delete "+user.firstName+' '+user.lastName,
            options:[
                {
                    text:"Delete",
                    function: "resolve"
                },
                {
                    text: "Cancel",
                    function: "reject"
                }
            ]
        }

        let shouldContinue = await warning.create(this, warningItem).then(() => {
            return true;
        }).catch(() => {
            return false;
        });

        if(shouldContinue){
            this.selectStaff();
            await frontendClient.postEx("walkers/delete",{
                id:user.id
            })
            Vue.delete(this.users, user);
        }
    }

    unpaidJobs: HTTPPostAPI["jobs/usergroups/unpaid/list"]["result"] = {
        list: [],
        totalHours: 0,
    };
    async getUnpaidList() {
        this.unpaidJobs =  {
            list: [],
            totalHours: 0,
        };

        if(!this.selectedStaff) {return;}
        
        this.unpaidJobs = await frontendClient.post("jobs/usergroups/unpaid/list",{
            userID: this.selectedStaff.id,
        });
    }
    
    async payHours() {
        if(!this.selectedStaff) {return;}
        if(!this.unpaidJobs) {return;}

        let errorInRequest:boolean = false;

        let requests: Promise<any>[] = [];

        for(let usergroup of this.unpaidJobs.list) {
            requests.push(frontendClient.post("jobs/usergroups/setpaid",{
                userID: this.selectedStaff.id,
                usergroupID: usergroup.usergroupID,
                userPaid: true,
            }));
        }

        try {
            await Promise.all(requests);
        }
        catch(e) {
            errorInRequest = true;
            frontendClient.giveError("Critical error, users were not completely paid: " + e.toString());
        }

        this.updateGraphs();

        if(errorInRequest) return;
        this.unpaidJobs =  {
            list: [],
            totalHours: 0,
        };
    }

    involvedJobs: HTTPPostAPI["jobs/list/user"]["result"]["jobs"] = [];
    pageNum:number = 1;
    shouldLoadNewJobs = true;
    async refreshInvolvedJobs(pageNum: number = 1) {
        if(pageNum === 1) {
            this.involvedJobs = [];
        }

        let newJobs = (await frontendClient.post("jobs/list/user",{
            page: pageNum,
            userID: this.selectedStaff.id,
            hasCompleted:true,
        })).jobs;

        if(newJobs.length === 0) {
            this.shouldLoadNewJobs = false;
        }

        this.involvedJobs = this.involvedJobs.concat(newJobs);
    }

    nextPage(){
        this.pageNum++;
        this.refreshInvolvedJobs(this.pageNum);
    }

    // date selectors
    openFromSelector(x){
        this.fromSelector = true;
    }
    openToSelector(x){
        this.toSelector = true;
    }
    closeFrom(x){
        this.fromSelector = false;
    }
    closeTo(x){
        this.toSelector = false;
    }
    closeRanges(){
        this.fromSelector = false;
        this.toSelector = false;
    }

    users = [];
    viewingUserID: string = null;

    mounted(){
       this.$emit('scope','clients'); // FIXME: should scope really be `clients`?
       this.loadUserList();
       this.getDates();
       this.updateGraphs();
    }

    timeStampToString(ts: number) {
        return moment(ts).format("ddd, Do MMM YY");
    }

    async loadUserList() {
        this.users = (await frontendClient.postEx("walkers/list",{})).list;
        this.changeFocus();  
    }

    editStaff(walker){
        this.$emit('editPrompt',{instance:'walker',object:walker});
    }

    updateSearch(newVal){
        this.searchVal = newVal;
        this.searchVal = this.searchVal?this.searchVal.toLowerCase():'';
    }

    selectStaff(user?){
        if(!user) user = null;
        this.selectedStaff = user;
        this.getUnpaidList();
        this.updateGraphs();
        this.refreshInvolvedJobs();
        this.shouldLoadNewJobs = true;
        this.involvedJobs = [];
    }

    async updateGraphs(){
        this.selectedStaffGraph = await frontendClient.post("graph/stats",{
            from: this.range.from,
            to: this.range.to,
            userID: this.selectedStaff?this.selectedStaff.id:"all"
        })
    }

    @Watch("$route.params.userID")
    changeFocus(){
        this.viewingUserID = null;
        if(this.$route.params.userID){
            for(let i=0;i<this.users.length;i++){
                if(this.users[i].id == this.$route.params.userID){
                    this.selectStaff(this.users[i]);
                    this.viewingUserID = this.users[i].id;
                    break;
                }
            }
        }
    }

}
